import styled from "styled-components";

export const Content = styled.section`
  position: relative;

  .slotsArea {
    display: flex;
  }

  .focusOnViewOnly:focus {
    border-radius: 2px;
    border: 5px solid #AAA;
  }
`;

export const SlotContainer = styled.div`
  width: 141px;
  height: 420px;
`;

export const ButtonSize = styled.button`
  width: 100%;
  background: #616161;
  border: none;
  border-radius: 4px;
  min-width: 60px;
  height: 31px;

  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  color: #fff;
  cursor: pointer;
`;
